import { Drawer } from "antd";
import { color } from "src/styles/globals";
import styled from "styled-components";
import { Title as SundayTitle } from "sunday-component";

export const Title = styled(SundayTitle)`
  color: ${color.charcoal10} !important;
`;

export const DrawerContainer = styled(Drawer)`
  box-shadow: none;
  z-index: 20;
  .ant-drawer-body {
    padding: 0;
    height: fit-content;
  }
`;

export const HorizontalDivider = styled.hr`
  border: none;
  height: 121px;
  width: 100%;
  margin: 0;
`;

export const Submenu = styled.div`
  font-size: 19px;
  width: 100%;
  display: flex;
  justify-content: center;
  vertical-align: middle;
`;

export const SubmenuContainer = styled.div`
  width: 100%;
  max-width: 1400px;

  a {
    color: #2a2c2e;
  }
  a * {
    color: #2a2c2e;
  }
  a:hover {
    color: #fa4616;
  }
  a:hover * {
    color: #fa4616;
  }
  padding-top: 2.5rem;
  line-height: 36px;
  color: #76777a;

  * {
    color: #76777a;
  }
  ul {
    padding-top: 1rem;
    padding-left: 0;
    margin-bottom: 2.5rem;
    list-style-type: none;
  }
  li {
    padding-top: 0.5rem;
    list-style: none;
  }
`;
